import { render, staticRenderFns } from "./ClientsReceiptList.vue?vue&type=template&id=1a55f229&scoped=true&"
import script from "./ClientsReceiptList.vue?vue&type=script&lang=js&"
export * from "./ClientsReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsReceiptList.vue?vue&type=style&index=0&id=1a55f229&lang=scss&scoped=true&"
import style1 from "./ClientsReceiptList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55f229",
  null
  
)

export default component.exports